import React, { Component } from 'react'
import { CommonValidationMessages } from '../../../utils/Messages';
import ItemMasterServices from '../../../services/axioServices/apiServices/ItemMasterServices';
import CommonServices from '../../../services/axioServices/apiServices/CommonServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import RawMaterialSampleEntryInputs from './RawMaterialSampleEntryInputs';
import QCServices from '../../../services/axioServices/apiServices/QCServices';
import { decryptAES } from '../../../utils/Encryption';
import moment from 'moment';
import MaterialListModelForQc from './MaterialListModelForQc';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import { Navigate } from 'react-router-dom';

export default class FinishProductsSampleEntryDetails extends Component {
    constructor(props) {
        super(props);
        this.qcServices = new QCServices();
        this.itemMasterServices = new ItemMasterServices();
        this.commonServices = new CommonServices();
        this.SwalServices = new SwalServices();
        this.state = {
            route: null,
            sampleEntryFGId: null,
            companyName: '',
            materialList: [],
            supplierList: [],
            labList: [],
            tableData: [],
            setGrnMaterialDetailspopUp: false,
            columns: [
                { field: 'productionNo', header: 'ProdNo No', width: '12%' },
                { field: 'productionPlanningDate', header: 'Planning Date', width: '15%' },
                { field: 'productName', header: 'Product Name', width: '28%' },
                { field: 'productBatchNo', header: 'Batch No', width: '20%' },
                { field: 'productQty', header: 'Batch size', width: '20%' },
                { field: 'action', header: 'Action', body: this.actionTemplate, sortable: false, width: '10%' }
            ],
            sampleObject: {
                productionId: "",
                refNo: "",
                receivedDate: "",
                refDate: "",
                prodNo: "",
                materialId: "",
                standard: "",
                batchNo: "",
                invNo: "",
                invDate: "",
                sampleQty: "",
                purchaseQty: "",
                mfgDate: "",
                expDate: "",
                contract: "",
                supplierId: "",
                contractNo: "",
                mfgBy: "",
                labName: "",
                isOutSideAnalysis: 0,
                remark: "",
            },
            isTestReportEntry: false,
            validationRules: {
                materialId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "material name"
                        ),
                    },
                ],
                supplierId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "supplier name"
                        ),
                    },
                ],
                sampleQty: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "sample qty"
                        ),
                    },
                ],
            },
            validState: {
                isValid: true,
                error: {},
            },
        }
    }

    componentDidMount = () => {
        let params = new URLSearchParams(window.location.search);
        let id = params.get("id")

        let props = getAuthProps()
        if (props && props.companyName) {
            this.setState({ companyName: props.companyName })
        }

        if (id) {
            let sampleEntryFGId = decryptAES(id)
            if (sampleEntryFGId) {
                if (sampleEntryFGId != null) {
                    this.setState({ sampleEntryFGId: sampleEntryFGId }, () => {
                        this.getFinishGoodsSampleEntryDetailsById(this.state.sampleEntryFGId)
                    });
                }
            }
        } else {
            this.getFinishGoodsSampleEntryCount()
        }
        this.getAllPartyDropdown()
    }

    getFinishGoodsSampleEntryDetailsById = (sampleEntryFGId) => {
        this.qcServices.getFinishGoodsSampleEntryDetailsById(sampleEntryFGId).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let details = this.state.sampleObject
                details.refNo = res.refNo
                details.refDate = res.refDate ? moment(res.refDate).format('YYYY-MM-DD') : ''
                details.prodNo = res.prodNo
                details.receivedDate = moment(res.receivedDate).format('YYYY-MM-DD')
                details.materialId = res.productId
                details.standard = res.standard
                details.batchNo = res.batchNo
                details.sampleQty = res.sampleQty
                details.purchaseQty = res.batchSize
                details.mfgDate = res.mfgDate ? moment(res.mfgDate).format('YYYY-MM-DD') : ''
                details.expDate = res.expDate ? moment(res.expDate).format('YYYY-MM-DD') : ''
                details.supplierId = res.supplierId
                details.mfgBy = res.mfgBy
                details.labName = res.labName
                details.isOutSideAnalysis = res.isOutSideAnalysis === true ? 1 : 0
                details.productionId = res.productionId
                details.remark = res.remark
                this.setState({ sampleObject: details, isTestReportEntry: res.isTestReportEntry })

            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    getFinishGoodsSampleEntryCount = () => {
        this.qcServices.getFinishGoodsSampleEntryCount().then((response) => {
            if (response.statusCode == 200 && response.responseData !== null) {
                let sampleObject = this.state.sampleObject
                sampleObject.refNo = response.responseData.refNo
                sampleObject.refDate = moment(new Date()).format('YYYY-MM-DD')
                this.setState({ sampleObject: sampleObject })
            }
        });
    };

    getAllPartyDropdown = () => {
        this.commonServices.getAllPartyDropdown().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let dropdownItems = res.map((item) => ({
                    label: item.partyName,
                    value: item._id,
                }));
                this.setState({ supplierList: dropdownItems }, () => {
                    this.getAllProductDropdown();
                });
            } else {
                this.getAllProductDropdown();
                this.SwalServices.Error(
                    response.Message
                );
            }
        });
    };

    getAllProductDropdown = () => {
        this.commonServices.getAllProductDropdown().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let dropdownItems = res.map((item) => ({
                    label: item.productName,
                    value: item._id,
                }));
                this.setState({ materialList: dropdownItems });
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    };

    handleChange = (event, name, section) => {
        let value = event.target.value;
        let details = this.state.sampleObject;
        details[name] = value.toUpperCase();
        this.setState({ sampleObject: details });
    };

    setFilterParametersForItemName = (selected, name) => {
        if (selected.value) {
            if (name === "materialId") {
                let sampleObject = this.state.sampleObject
                sampleObject.materialId = selected.value;
                sampleObject.standard = selected.standard;
                this.setState({ sampleObject: sampleObject });
            } else {
                let sampleObject = this.state.sampleObject;
                sampleObject[name] = selected.value;
                this.setState({ sampleObject: sampleObject });
            }
        }
    }

    handleToggle = (e) => {
        let checked = e.target.checked;
        this.setState({
            sampleObject: {
                ...this.state.sampleObject,
                isOutSideAnalysis: checked ? 1 : 0
            }
        });
    }

    getProductionItemsByProductionNo = () => {
        this.qcServices.getProductionItemsByProductionNo([this.state.sampleObject.prodNo]).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                this.setState({ tableData: response.responseData }, () => {
                    this.setState({ setGrnMaterialDetailspopUp: true })
                })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    };

    setOpenModel = () => {
        this.setState({ setGrnMaterialDetailspopUp: !this.state.setGrnMaterialDetailspopUp });
    };

    actionTemplate = (rowData) => {
        return (
            <div className="flex gap-2">
                <button
                    className="search-btn w-[28px] h-[28px] bg-blue text-white rounded"
                    onClick={() => this.handleSelectMaterial(rowData)}
                >
                    <FontAwesomeIcon icon={faArrowRight} className='w-[14px] h-[14px]' />
                </button>
            </div>
        );
    };

    handleSelectMaterial = (rowData) => {
        let details = this.state.sampleObject
        details.receivedDate = moment(rowData.productionPlanningDate, "DD-MM-YYYY").format("YYYY-MM-DD");
        details.materialId = rowData.productId
        details.batchNo = rowData.productBatchNo
        details.invoiceNo = rowData.productionNo
        details.invoiceDate = moment(rowData.productionPlanningDate).format('YYYY-MM-DD')
        details.purchaseQty = rowData.productQty
        details.mfgDate = rowData.productMfgDate
            ? moment(rowData.productMfgDate).format('YYYY-MM-DD')
            : null

        details.expDate = rowData.productExpDate
            ? moment(rowData.productExpDate).format('YYYY-MM-DD')
            : null
        details.mfgBy = rowData.materialMfgBy
        details.prodNo = rowData.productionNo
        details.productionId = rowData._id
        details.mfgBy = this.state.companyName
        this.setState({ sampleObject: details }, () => {
            this.setState({ setGrnMaterialDetailspopUp: false });
        })
    }

    setFilterParametersForItemName = (selected, name) => {
        if (selected.value) {
            let sampleObject = this.state.sampleObject;
            sampleObject[name] = selected.value;
            this.setState({ sampleObject: sampleObject });
        }
    }

    isAllFieldsValidate = () => {
        const newValidState = isValidForm(
            this.state.sampleObject,
            this.state.validationRules,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid
    }

    addEditFinishGoodsSampleEntry = () => {
        if (this.state.isTestReportEntry === false) {
            let isValid = this.isAllFieldsValidate()
            if (isValid) {
                let sampleObject = this.state.sampleObject
                let request = {
                    refNo: sampleObject.refNo,
                    refDate: sampleObject.refDate,
                    prodNo: sampleObject.prodNo,
                    receivedDate: sampleObject.receivedDate,
                    batchNo: sampleObject.batchNo,
                    sampleQty: sampleObject.sampleQty,
                    batchSize: sampleObject.purchaseQty,
                    mfgDate: sampleObject.mfgDate,
                    expDate: sampleObject.expDate,
                    supplierId: sampleObject.supplierId,
                    mfgBy: sampleObject.mfgBy,
                    isOutSideAnalysis: sampleObject.isOutSideAnalysis,
                    labName: sampleObject.labName,
                    productionId: sampleObject.productionId,
                    productId: sampleObject.materialId,
                    remark: sampleObject.remark
                }
                if (this.state.sampleEntryFGId) {
                    request.sampleEntryFGId = this.state.sampleEntryFGId
                }
                this.qcServices.addEditFinishGoodsSampleEntry(request).then((response) => {
                    if (response.statusCode === 200 && response.responseData !== null) {
                        if (this.state.sampleEntryFGId) {
                            this.navigate()
                        } else {
                            this.navigate()
                        }
                        this.SwalServices.Success(response.Message)
                    } else {
                        this.SwalServices.Error(response.Message);
                    }
                })
            }
        } else {
            this.SwalServices.Warning('Test report is already added for this sample. So, you can not edit the details.');
        }
    }

    generateSampleEntryFGReport = () => {
        this.setState({ isLoading: 'print' }, () => {
            let request = [this.state.sampleEntryFGId]
            this.qcServices.generateSampleEntryFGReport(request).then((response) => {
                if (response && response.status === 200) {
                    let blob = new Blob([response.data], { type: 'application/pdf' });
                    // let blob = new Blob([response.data])
                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.target = '_blank';
                    link.click();
                    this.setState({ isLoading: "" })
                }
                this.setState({ isLoading: false });
            })
        })
    }

    navigate = () => {
        this.setState({ route: '/FinishProductSampleEntry' })
    }

    render() {
        if (this.state.route !== null) {
            return <Navigate to={this.state.route} />;
        }
        return (
            <div className='raw-sample-fields'>
                <h1 className='text-[20px] font-semibold text-blue pb-[5px] mb-[5px]'>Finish Products Sample Entry</h1>
                <RawMaterialSampleEntryInputs
                    sampleObject={this.state.sampleObject}
                    handleChange={this.handleChange}
                    handleToggle={this.handleToggle}
                    materialList={this.state.materialList}
                    supplierList={this.state.supplierList}
                    labList={this.state.labList}
                    sampleEntryType='FinishProducts'
                    getGRNItemsByGRNNo={this.getProductionItemsByProductionNo}
                    setFilterParametersForItemName={this.setFilterParametersForItemName}
                    validState={this.state.validState}
                />
                <div className='btn-grp flex items-center gap-5 mt-2.5 pt-2.5 border-t border-gray-200'>
                    <button className='search-btn' onClick={this.addEditFinishGoodsSampleEntry}>
                        {this.state.sampleEntryFGId ? 'Save' : 'Add'}
                    </button>
                    <button className='cancel-btn' onClick={this.navigate}>Cancel</button>
                    {this.state.sampleEntryFGId !== null && this.state.sampleEntryFGId !== undefined && this.state.sampleEntryFGId !== "" ?
                        <button className='print-btn' onClick={this.generateSampleEntryFGReport}>Print</button>
                        : null}
                </div>
                <MaterialListModelForQc
                    tableData={this.state.tableData}
                    columns={this.state.columns}
                    setGrnMaterialDetailspopUp={this.state.setGrnMaterialDetailspopUp}
                    sampleObject={this.state.sampleObject}
                    setOpenModel={this.setOpenModel}
                    sampleEntryType='FinishProducts'
                />
            </div>
        )
    }
}
